// extracted by mini-css-extract-plugin
module.exports = {"icon":"_175a04f","large":"_eae73ea","dropdown":"_623846b"};